import { updatePageProps } from '@eventbrite/datalayer-library';
import { hasUrgencySignalsEnabled } from '@eventbrite/urgency-signals';
import { AppProps } from '../types';

export const dataLayerMiddleware = (props: Partial<AppProps>) => {
    const isRepeatingEvent =
        props.event?.isSeriesParent && !!props.event?.childEvents;

    const page = {
        eventId: props.event?.id,
        isPaid: props.components?.eventDetails.refund?.isPaidEvent,
        isFree: !props.components?.eventDetails.refund.isPaidEvent,
        isOnline: props.event?.isOnlineEvent,
        isPrivate: props.event?.isProtected,
        isListed: props.event?.isListed,
        isLive: props.event?.isLive,
        isRepeatingEvent: isRepeatingEvent,
        isSeriesParent: props.event?.isSeriesParent,
        eventStatus: props.event?.salesStatus.sales_status,
        hasUrgencySignals: hasUrgencySignalsEnabled(props.urgencySignals),
        hasEarlyBirdUrgencySignal: props.urgencySignals?.categories.earlyBird,
        hasNewUrgencySignal: props.urgencySignals?.categories.new,
        hasPopularUrgencySignal: props.urgencySignals?.categories.popular,
        hasFewTicketsLeftUrgencySignal:
            props.urgencySignals?.messages.fewTickets,
        hasSalesEndSoonUrgencySignal:
            props.urgencySignals?.messages.salesEndSoon,
        eventStartDate: props.event?.start.utc,
        eventEndDate: props.event?.end.utc,
    };

    updatePageProps({
        page,
    });
};
